import { AfterViewInit, Component, Input } from "@angular/core";
import { DeliveryNoteLineItemData } from "@interfaces/data/deliveryNoteLineItemData.interface";

@Component({
	moduleId: module.id,
	selector: "deliveryNoteLineItemGridDetails",
	styleUrls: ["deliveryNoteLineItemGridDetails.css"],
	templateUrl: "deliveryNoteLineItemGridDetails.html"
})
export class DeliveryNoteLineItemGridDetailsComponent implements AfterViewInit {
	@Input() lineItemData = "";
	lineItems: DeliveryNoteLineItemData[] = [];
  
	ngAfterViewInit() {
		this.lineItems = JSON.parse(this.lineItemData);
	}
}